import { Box, Button, Checkbox, Typography } from "@mui/material";
import { getPrettyDateTime } from "../../../../../utils/timestamp";

const EmailListItem = ({
  email,
  isSelected,
  onSelect,
  onEdit,
  onDuplicate,
  onDelete,
  isDisabled = false,
}) => {
  return (
    <Box
      border={1}
      borderColor="grey.300"
      borderRadius={1}
      p={2}
      sx={{
        "&:hover": {
          borderColor: "primary.main",
          bgcolor: "action.hover",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(email, e.target.checked)}
            size="small"
            disabled={isDisabled}
          />
          <Typography variant="subtitle2">
            <strong>Customer:</strong> {email.customer_id}
          </Typography>
        </Box>
        <Box display="flex" gap={1}>
          <Button
            size="small"
            onClick={() => onEdit(email)}
            disabled={isDisabled}
          >
            Edit
          </Button>
          <Button
            size="small"
            color="secondary"
            onClick={() => onDuplicate(email)}
            disabled={isDisabled}
          >
            Duplicate
          </Button>
          <Button
            size="small"
            color="error"
            onClick={() => onDelete(email)}
            disabled={isDisabled}
          >
            Delete
          </Button>
        </Box>
      </Box>
      <Typography variant="body2">
        <strong>Subject:</strong> {email.subject}
      </Typography>
      <Typography variant="body2">
        <strong>To:</strong> {email.to_addresses?.join(", ")}
      </Typography>
      {email.bcc_addresses?.length > 0 && (
        <Typography variant="body2">
          <strong>BCC:</strong> {email.bcc_addresses.join(", ")}
        </Typography>
      )}
      <Typography variant="body2">
        <strong>Scheduled:</strong>{" "}
        {getPrettyDateTime(email.scheduled_time, true)}
      </Typography>
    </Box>
  );
};

export default EmailListItem;
